<template>
    <div class="d-flex justify-content-between w-100">
        <dl>
            <dt>Connected to Cinolla</dt>
            <dd>
                <i
                    class="fa"
                    :class="{
                        'fa-check text-success': props.hasApiKey,
                        'fa-times text-danger': ! props.hasApiKey,
                    }"
                ></i>
            </dd>
        </dl>

        <div>
            <button v-if="(! props.hasApiKey) && showForm === false" v-on:click="showForm = ! showForm" class="btn btn-small btn-warning">Connect To Cinolla</button>
        </div>
    </div>

    <form v-if="showForm" class="pb-3" method="POST" :action="props.route">
        <input name="_token" :value="csrf" type="hidden" />

        <div class="mb-4">
            <label class="form-label" for="cinolla_api_key">Cinolla API Key</label>
            <input :value="props.oldValue" type="text"
                class="form-control" :class="{'is-invalid': props.validationError.length}" id="cinolla_api_key" name="cinolla_api_key" required>

            <div v-if="props.validationError.length" class="invalid-feedback" v-text="props.validationError"></div>
        </div>

        <button type="submit" class="btn btn-alt-success">Save</button>
    </form>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
    csrf: String,
    hasApiKey: Boolean,
    oldValue: String,
    route: String,
    validationError: String,
});

const showForm = ref(false);

if (props.validationError.length) {
    showForm.value = true;
}
</script>
